import type { FC } from 'react';

import DownloadCta from '@/features/home/components/DownloadCta';
import FaqSection from '@/features/home/components/FaqSection';
import FeatureGrid from '@/features/home/components/FeatureGrid';
import HeroSection from '@/features/home/components/HeroSection';
import HowItWorksSection from '@/features/home/components/HowItWorksSection';
import TrustSection from '@/features/home/components/TrustSection';
import { useHomePage } from '@/features/home/hooks/useHomePage.hook';

const HomePage: FC = () => {
  const { heroStats, steps, features, trustPoints, faqItems, storeBadges } = useHomePage();

  return (
    <>
      <HeroSection stats={heroStats} />
      <HowItWorksSection steps={steps} />
      <FeatureGrid features={features} />
      <TrustSection points={trustPoints} />
      <FaqSection items={faqItems} />
      <DownloadCta badges={storeBadges} />
    </>
  );
};

export default HomePage;
